export const TIPO_REMESA = {
  CORE: 0,
  B2B: 1,
} as const

export type TipoRemesaType = (typeof TIPO_REMESA)[keyof typeof TIPO_REMESA]
